import { useCallback } from "react";
import { useSelector } from "react-redux";

import { strCode } from "../../consts";
import { log, notificationService, t, userGroupService } from "../../services";

const createGroups = async (groups, onPushGroupId) => {
  try {
    const promises = [];

    for (let group of groups) {
      promises.push(userGroupService.createGroup(group, onPushGroupId));
    }

    await Promise.all(promises);
  } catch (err) {
    log.error("createGroups: Failed to create groups", err);

    notificationService.showError({
      title: t(strCode.GROUP_EDIT_ERROR),
      message: err?.response?.data?.message ? err.response.data.message : err?.toString()
    });
  }
};

export const useAssignGroups = () => {
  const groups = useSelector((store) => store.userGroups?.groups);

  const mutationCallback = useCallback(
    async (email, previousAssignments, groupAssignments, isAdmin) => {
      try {
        const newGroups = groupAssignments.filter(
          (x) => !groups.some((newGroup) => newGroup.id === x)
        );

        let addedTargetGroups = groupAssignments.filter(
          (x) => !newGroups.includes(x) && !previousAssignments?.includes(x)
        );

        const removedTargetGroups =
          previousAssignments?.filter((x) => !groupAssignments.includes(x)) ?? [];

        let newGroupIds = [];

        const onPushGroupId = (id) => {
          newGroupIds = [...newGroupIds, id];
        };

        if (newGroups?.length) {
          await createGroups(newGroups, onPushGroupId);
        }

        if (newGroupIds?.length) {
          addedTargetGroups = [...addedTargetGroups, ...newGroupIds];
        }

        if (addedTargetGroups?.length || removedTargetGroups?.length) {
          const data = {
            email,
            isAdmin: !!isAdmin,
            addedTargetGroups,
            removedTargetGroups
          };

          await userGroupService.updateUserGroups(data)
        }
      } catch (err) {
        log.error("useAssignGroups: Failed to assign groups", err);

        notificationService.showError({
          title: t(strCode.GROUP_EDIT_ERROR),
          message: err?.response?.data?.message ? err.response.data.message : err?.toString()
        });
      }
    },
    [groups]
  );

  return { mutationCallback };
};
